import ClientProductsPage from "./ClientProductsPage";

export default ClientProductsPage;
